import React, { useEffect }  from 'react';
import PropTypes from 'prop-types';
import StyledButton from 'common/StyledButton';
import css from './MultipleCheckInsOption.css'
import TextHeader from "./TextHeader";
import  NumberToWords  from 'number-to-words';
import {isCheckedIn, isSelfService, serviceInKioskCheckedIn, getVirtualKioskLink} from "../utils/kiosk";

function MultipleCheckInsOption(props) {

  const buildWarningMessage  = () => {
    const servicesCheckedInto = props.allServices.filter(isCheckedIn);
    if (servicesCheckedInto.length > 0) {
      let servicesMessage = "";
      switch (servicesCheckedInto.length) {
        case 1:
          servicesMessage = `${servicesCheckedInto[0].name}.`;
          break;
        case 2:
          servicesMessage = `${servicesCheckedInto[0].name} and ${servicesCheckedInto[1].name}`;
          break;
        default:
          servicesMessage = `${servicesCheckedInto[0].name} and ${NumberToWords.toWords(servicesCheckedInto.length - 1)} others.`
      }
      props.setWarning("You are still checked in to " + servicesMessage);
    }
  };

  useEffect(()=> {
    buildWarningMessage()
  }, [props.allServices]);

  // Restrict students from checking in to more than one service of a virtual self-service kiosk
  if (props.virtualSignInEnabled
      && isSelfService(props.kioskType)
      && serviceInKioskCheckedIn(props.kioskId, props.allServices).length > 0) {

    const serviceAlreadyCheckedIn = serviceInKioskCheckedIn(props.kioskId, props.allServices)[0];
    return (
        <div className={css['self-service-message']}
             aria-label={`You must check out from ${serviceAlreadyCheckedIn.name} before you can check in at this service`}>
          You must check out from <b>{serviceAlreadyCheckedIn.name}</b> before you can check in at this service.
          <a href={getVirtualKioskLink(props.kioskId, serviceAlreadyCheckedIn.serviceId)}
             aria-label={`Go to ${serviceAlreadyCheckedIn.name} to check out`}>
            Go to service to check out
          </a>
        </div>
    );
  }

  return (
    <div>
      <div className={css['content']}>
        <TextHeader id="multipleCheckInsSelection"
                    upperText={props.greetingText}
                    lowerText={props.instructionsText} />
        <div className={css['buttons-container']} aria-labelledby="multipleCheckInsSelection">
          <StyledButton inverted onClick={props.startOver}>
            NO
          </StyledButton>
          <StyledButton onClick={props.onConfirmMultipleCheckIn}>
            YES
          </StyledButton>
        </div>
      </div>
    </div>
  );
}

MultipleCheckInsOption.propTypes = {
  greetingText: PropTypes.string.isRequired,
  instructionsText: PropTypes.string.isRequired,
  onConfirmMultipleCheckIn: PropTypes.func.isRequired,
  startOver: PropTypes.func.isRequired,
  setWarning: PropTypes.func.isRequired,
  allServices: PropTypes.arrayOf(Object).isRequired,
  virtualSignInEnabled: PropTypes.bool.isRequired,
  kioskId: PropTypes.number.isRequired,
  kioskType: PropTypes.string
};

export default MultipleCheckInsOption;
